import Comparison from './Comparison'

export default class GreaterThan extends Comparison {
  get ruleName () {
    return 'greaterThan'
  }

  passesStringOrArray () {
    return this.value.length > parseInt(this.number)
  }

  passesNumber () {
    return this.value > parseFloat(this.number)
  }

  passesString () {
    return this.passesStringOrArray()
  }

  passesArray () {
    return this.passesStringOrArray()
  }
}
